export default "__VITE_ASSET__DFHHKSyb__"